import React from 'react';

function BuildDateTime() {
  const buildDateTime = '28 April 2026, 11:30 PM';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-2xl font-semibold text-gray-900">Build Date & Time Page</h1>
        <p className="mt-2 text-sm text-gray-500">Simple date and time</p>
        <p className="mt-6 text-lg font-medium text-gray-800">
          {buildDateTime}
        </p>
      </div>
    </div>
  );
}

export default BuildDateTime;
